module.exports = __webpack_public_path__ + "img/921_page_background_people2_pc.0beaa41a.jpg";